import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface PrivacyPolicyProps {
  appName: string;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ appName }) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const response = await fetch('/PRIVACY_POLICY.md');
        const text = await response.text();
        setContent(text);
      } catch (error) {
        console.error('Error fetching privacy policy:', error);
        setContent('Privacy policy content could not be loaded.');
      } finally {
        setLoading(false);
      }
    };

    fetchPrivacyPolicy();
  }, []);

  const formatMarkdownToHtml = (markdown: string) => {
    return markdown
      // Headers
      .replace(/^### (.*$)/gim, '<h3>$1</h3>')
      .replace(/^## (.*$)/gim, '<h2>$1</h2>')
      .replace(/^# (.*$)/gim, '<h1>$1</h1>')
      // Bold
      .replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>')
      // Lists
      .replace(/^- (.*$)/gim, '<li>$1</li>')
      // Line breaks
      .replace(/\n/gim, '<br/>')
      // Wrap lists
      .replace(/<li>.*<\/li>/gim, '<ul>$&</ul>')
      // Links
      .replace(/\[(.*?)]\((.*?)\)/gim, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  };

  if (loading) {
    return (
      <section className="section">
        <div className="container">
          <div style={{ textAlign: 'center', padding: '4rem 0' }}>
            <p>Loading privacy policy...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <div style={{ marginBottom: '2rem' }}>
          <Link 
            to="/" 
            style={{ 
              color: 'var(--accent-color)', 
              textDecoration: 'none',
              fontSize: '1rem',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            ← Back to Home
          </Link>
        </div>
        
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            fontWeight: '700',
            marginBottom: '1rem',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}>
            {appName} Privacy Policy
          </h1>
          <div className="section-divider"></div>
        </div>

        <div 
          style={{ 
            maxWidth: '800px', 
            margin: '0 auto',
            lineHeight: '1.6',
            fontSize: '1rem'
          }}
          dangerouslySetInnerHTML={{ 
            __html: formatMarkdownToHtml(content) 
          }}
        />
      </div>
    </section>
  );
};

export default PrivacyPolicy; 